import { ImmomioSpinner } from '@immomio/ui/spinner';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  input,
  output
} from '@angular/core';
import { Comment } from '@ui/shared/model';
import { TranslatePipe } from '@ngx-translate/core';
import {
  ImmomioDropdown,
  ImmomioDropdownTrigger,
  ImmomioDropdownMenu,
  ImmomioDropdownGroup,
  ImmomioDropdownItem
} from '@immomio/ui/dropdown';
import {
  ImmomioIconButtonComponent,
  ImmomioButtonComponent
} from '@immomio/ui/button';
import { DateTimePipe } from '../../../pipes/date-time.pipe';
import { AppInputDirective } from '../form/controls/input/input.directive';
interface EditableComment extends Comment {
  editMode?: boolean;
}

@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ImmomioSpinner,
    ImmomioButtonComponent,
    ImmomioDropdown,
    ImmomioDropdownTrigger,
    ImmomioDropdownMenu,
    ImmomioDropdownGroup,
    ImmomioDropdownItem,
    ImmomioIconButtonComponent,
    AppInputDirective,
    TranslatePipe,
    DateTimePipe
  ]
})
export class CommentsComponent {
  @Input() get comments(): Comment[] {
    return this.editableComments;
  }
  set comments(comments) {
    this.editableComments = comments.map(comment => ({
      ...comment,
      editMode: false
    }));
  }

  readonly updatingComment = input<boolean>(undefined);
  readonly userId = input<string>(undefined);
  readonly allowCommentEdit = input(true);

  readonly showProperty = output<string>();
  readonly updateComment = output<Comment>();
  readonly deleteComment = output<string>();

  public editableComments: EditableComment[];

  public onShowProperty(id: string) {
    this.showProperty.emit(id);
  }

  public editComment(index: number) {
    this.editableComments[index].editMode = true;
  }

  public onDeleteComment(id: string) {
    this.deleteComment.emit(id);
  }

  public cancelEdit(index: number) {
    this.editableComments[index].editMode = false;
  }

  public onUpdateComment(editableComment: EditableComment, comment: string) {
    this.updateComment.emit({ id: editableComment?.id, comment } as Comment);
  }
}
